import React from "react";
import { useQueryClient } from "@tanstack/react-query";
import { UseGetTour, UseSaveTour } from "../../../api/calls/Queries";
import QuizSelector from "./QuizSelector";
import { useForm, SubmitHandler } from "react-hook-form";
import { TourData, Scene } from "../../../Types";
import { useCurrentSceneStore, useTourDataStore } from "../../../api/Zustand";
import { getLanguageFile } from "../../common/GetLanguageFile";
import { SaveButton } from "./UiElements";
// import { getLanguageFile } from "../../common/GetLanguageFile";

function TourInfoEditing({ tourID }: { tourID: number }) {
  const { setCurrentSceneID } = useCurrentSceneStore();

  const { mutateAsync: saveTour, isPending } = UseSaveTour();

  const { data: tourData } = UseGetTour(tourID);
  // const { tourData } = useTourDataStore();

  const { register, handleSubmit, formState, watch, reset, setValue } =
    useForm<TourData>();

  const formData = watch();
  const queryClient = useQueryClient();

  React.useEffect(() => {
    if (tourData?.fov) {
      reset(tourData);
    }
  }, [reset, tourData]);

  const onSubmit: SubmitHandler<TourData> = (data) => {
    const newData = { ...tourData, ...data };

    return saveTour(newData, {
      onSuccess: (callResp) => {
        try {
          const data: {
            idTour: number;
            jsonData: string[];
            userId: number;
          } = JSON.parse(callResp.config.data);

          const jsonData: TourData = JSON.parse(data.jsonData[0]);

          if (jsonData) {
            queryClient.setQueryData(["GetTour", tourID], jsonData);

            reset(jsonData);
          }
        } catch (e) {
          throw e;
        }
      },

      // reset(JSON.parse(JSON.parse(callResp.config.data).jsonData)),
    });

    // saveTour(

    //   {
    //     ...tourData,
    //     // title: data.title,
    //     fov: data.fov,
    //     startingScene: data.startingScene,
    //   } as TourData,
    //   {
    //     onSuccess: (callResp) => {
    //       try {
    //         const data: {
    //           idTour: number;
    //           jsonData: string[];
    //           userId: number;
    //         } = JSON.parse(callResp.config.data);

    //         const jsonData = JSON.parse(data.jsonData[0]);

    //         reset(jsonData);
    //       } catch (e) {
    //         throw e;
    //       }
    //     },

    //     // reset(JSON.parse(JSON.parse(callResp.config.data).jsonData)),
    //   }
    // );
  };

  if (tourData)
    return (
      <div
        className="right-side-panel-editor"
        style={{
          height: "100%",
          boxSizing: "border-box",
        }}
      >
        {
          <div
            className="tour-info-page"
            style={{
              display: "flex",
              flexDirection: "column",

              height: "100%",
            }}
          >
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="hookform"
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 0,
              }}
            >
              <div className="category-divider">
                <h3 style={labelStyle}>TOUR</h3>
                <hr />
              </div>
              <label
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <input
                  disabled
                  type="text"
                  defaultValue={tourData.title}
                  // {...register("title")}
                  // placeholder="Dai un titolo al tour"

                  style={{
                    color: "#fff",
                    fontWeight: "600",
                    border: "none",
                    background: "#fff4",
                  }}
                />
                {/* <small style={{ opacity: formState.errors.title ? 1 : 0 }}>
                Titolo richiesto!
              </small> */}
              </label>

              <label>
                <h4 style={{ fontWeight: 600 }}>
                  {getLanguageFile("right_panel.initial_scene")}
                </h4>
                <select
                  defaultValue={tourData.startingScene}
                  style={{
                    padding: 4,
                    background: "#fff",
                  }}
                  {...register("startingScene", {
                    valueAsNumber: true,
                    onChange: (e: React.ChangeEvent<HTMLSelectElement>) =>
                      setCurrentSceneID(JSON.parse(e.target.value)),
                  })}
                >
                  {tourData.scenes.length === 0 && (
                    <option disabled value={undefined}>
                      {" "}
                      {getLanguageFile("right_panel.no_scenes")}
                    </option>
                  )}

                  {tourData.scenes.map((sc: Scene) => (
                    <option key={sc.id} value={sc.id}>
                      {sc.title}
                    </option>
                  ))}
                </select>
              </label>

              <label>
                <h4
                  style={{
                    fontWeight: "600",
                  }}
                >
                  {getLanguageFile("right_panel.initial_fov")}{" "}
                  <span style={{ fontWeight: 900 }}>
                    {formData.fov ? formData.fov : tourData.fov}°
                  </span>
                </h4>

                <input
                  type="range"
                  {...register("fov", {
                    min: 50,
                    max: 90,
                    setValueAs: (v) => {
                      return parseInt(v);
                    },
                  })}
                  min={50}
                  max={90}
                />
              </label>

              <div className="category-divider">
                <h3 style={labelStyle}>
                  {getLanguageFile("right_panel.quiz")}
                </h3>
                <hr />
              </div>
              <label htmlFor="quizSelector">
                <QuizSelector
                  tourData={tourData}
                  tourID={tourID}
                  formData={formData}
                  setValue={setValue}
                  register={register}
                  watch={watch}
                />
              </label>

              <div style={{ display: "flex" }}>
                <SaveButton
                  id="save"
                  type="submit"
                  style={{ flex: 1 }}
                  disabled={!formState.isDirty || isPending}
                  savingBool={isPending}
                ></SaveButton>

                <button
                  style={{ flex: 1 }}
                  type="reset"
                  disabled={!formState.isDirty}
                  onClick={() => reset(tourData)}
                >
                  {getLanguageFile("generics.cancel")}
                </button>
              </div>
            </form>
            {/* <textarea value={JSON.stringify(formData)} /> */}
          </div>
        }
      </div>
    );

  //
}

export default TourInfoEditing;

const labelStyle: React.CSSProperties = {
  fontSize: "1.1rem",
  fontWeight: "700",
};

const horizontalLineStyle: React.CSSProperties = {
  background: "#fffa",
  width: "100%",
  height: "1px",
  border: "none",
};
